// import Vue from 'vue'
import request from '@/utils/request'

export default {
    //oauth
    //受信任token相关接口 => 按条件查询用户信息
    searchUserInfoby(data) {
        return request({
            url: '/api/confidential/get-user-by-conditions?' + data,
            method: 'get',
        })
    },
    // //授权码授权-获取授权码
    // getApplyNum(data) {
    //     return request({
    //         url: 'oauth/authorize?client_id=1&redirect_uri=' + Vue.prototype.varHost + 'test/oauthcallback&response_type=code',
    //         method: 'get',
    //     })
    // },
    //获取用户基本信息(id)
    getUserBase(data) {
        return request({
            url: '/user/basic',
            method: 'get',
        })
    },
    //获取用户个人资料
    getUserPersonInfo(data) {
        return request({
            url: '/user/info',
            method: 'get',
        })
    },

    //密码授权
    pwdApply(data) {
        return request({
            url: '/oauth/token',
            method: 'post',
        })
    },
    //受信任服务直接授权
    oauthServerApply(data) {
        return request({
            url: '/oauth/token',
            method: 'post',
        })
    },
    //授权码授权-获取token
    getToken(data) {
        return request({
            url: '/oauth/token',
            method: 'post',
        })
    },

    // 注册登录流程
    //get
    //登录获取验证码  
    getMsgLogin(data) {
        return request({
            url: '/auth/mobile-login/verify-code?mobile=' + data.mobile + '&captcha=' + data.captcha,
            method: 'get'
        })
    },
    getMsgNewLogin(data) {
        return request({
            url: '/auth/mobile-login/verify-code/get-code',
            method: 'POST',
            data
        })
    },
    //注册获取图形验证码  
    getImgCheckCodeR(data) {
        return request({
            url: '/auth/register/captcha',
            method: 'get'
        })
    },
    //登录获取图形验证码  
    getImgCheckCodeL(data) {
        return request({
            url: '/auth/login/captcha',
            method: 'get',
        })
    },

    //注册获取验证码  
    getMsgRegist(data) {
        return request({
            url: '/auth/register/verify-code?mobile=' + data.mobile + '&captcha=' + data.captcha,
            method: 'get'
        })
    },
    getMsgNewRegist(data) {
        return request({
            url: '/auth/register/verify-code/get-code',
            method: 'post',
            data
        })
    },
    //社交账号绑定手机号-获取手机验证码  
    getMsgSocialBind(data) {
        return request({
            url: '/auth/socialite/bind-account/verify-code?mobile=' + data,
            method: 'get',
        })
    },
    socialAccLogin(data) {
        return request({
            url: '/auth/socialite/weibo',
            method: 'get',
        })
    },

    //post
    // 手机/邮箱 密码登录
    pwdLogin(data) {
        return request({
            url: '/auth/login',
            method: 'post',
            data
        })
    },
    // 手机验证码登录
    msgLogin(data) {
        return request({
            url: '/auth/mobile-login',
            method: 'post',
            data
        })
    },
    // 注册
    register(data) {
        return request({
            url: '/auth/register',
            method: 'post',
            data
        })
    },
    // 注册-校验手机号是否存在

    registerPhoneCheck(data) {
        return request({
            url: '/auth/mobile-exist',
            method: 'post',
            data
        })
    },
    //忘记密码获取验证码  
    getMsgForgot(data) {
        return request({
            url: '/auth/password/forgot/verify-code?account=' + data,
            method: 'get',
        })
    },
    // 忘记密码
    forgotPwd(data) {
        return request({
            url: '/auth/password/forgot',
            method: 'post',
            data
        })
    },
    // 忘记密码-校验验证码
    forgotPwdCheck(data) {
        return request({
            url: '/auth/password/forgot/verify-code',
            method: 'post',
            data
        })
    },
    // 社交账号绑定手机号
    socialPhoneBind(data) {
        return request({
            url: '/auth/socialite/bind-account',
            method: 'post',
            data
        })
    },

    //个人中心
    //get
    //个人信息
    getUserInfo(data) {
        return request({
            url: '/userinfo',
            method: 'get'
        })
    },

    //找回密码-获取图形码
    getCaptcha(data) {
        return request({
            url: '/auth/password/forgot/captcha',
            method: 'get'
        })
    },
    
    //找回密码-图形码
    checkCaptcha(data) {
        data.step = data.step?data.step: ''
        return request({
            url: '/auth/password/forgot/verify-code?account=' + data.account + '&captcha=' + data.captcha + '&step=' + data.step,
            method: 'get'
        })
    },
    checkCaptchaNew(data) {
        return request({
            url: '/auth/password/forgot/verify-code/get-code',
            method: 'post',
            data
        })
    },
    //修改密码-获取验证码
    getBackPwdCheck(data) {
        return request({
            url: '/password/reset/verify-code?mobile=' + data,
            method: 'get'
        })
    },
    //绑定手机号-获取验证码
    getMsgBindPhone(data) {
        return request({
            url: '/bind-mobile/verify-code?mobile=' + data,
            method: 'get'
        })
    },
    //绑定手机号-获取原手机验证码
    getOldMsgBindPhone(data) {
        return request({
            url: '/bind-mobile/old/verify-code?mobile=' + data,
            method: 'get'
        })
    },
    //绑定邮箱-获取邮箱验证码
    getEmailMsgBind(data) {
        return request({
            url: '/bind-email/verify-code?email=' + data,
            method: 'get'
        })
    },
    //绑定社交账号
    getBindSocialAcc(data) {
        return request({
            url: '/bind-socialite/weibo',
            method: 'get'
        })
    },
    //注销(删除)账号-获取手机验证码
    cancelAccCheck(data) {
        return request({
            url: '/delete-account/verify-code?mobile=' + data,
            method: 'get'
        })
    },
    //post
    //修改密码
    resetPwd(data) {
        return request({
            url: '/password/reset',
            method: 'post',
            data
        })
    },
    //修改密码-校验验证码
    resetPwdCheck(data) {
        return request({
            url: '/password/reset/verify-code',
            method: 'post',
            data
        })
    },
    //修改头像
    changeAvatar(data) {
        return request({
            url: '/update/avatar',
            method: 'post',
            data
        })
    },
    //修改名称
    changeName(data) {
        return request({
            url: '/update/name',
            method: 'post',
            data
        })
    },
    //绑定手机号
    bindPhone(data) {
        return request({
            url: '/bind-mobile',
            method: 'post',
            data
        })
    },
    //绑定手机号-校验原手机验证码
    bindPhoneCheck(data) {
        return request({
            url: '/bind-mobile/old/verify-code',
            method: 'post',
            data
        })
    },
    //绑定邮箱
    bindEmail(data) {
        return request({
            url: '/bind-email',
            method: 'post',
            data
        })
    },

    //绑定邮箱
    realBind(data) {
        return request({
            url: '/bind-idcard',
            method: 'post',
            data
        })
    },
    // 解绑社交账号
    unBindSocialAcc(which, data) {
        return request({
            url: '/unbind-socialite/' + which,
            method: 'post',
            data
        })
    },
    // 退出
    logOut(data) {
        return request({
            url: '/auth/logout',
            method: 'post',
            data
        })
    },
    // 注销
    cancelAcc(data) {
        return request({
            url: '/delete-account',
            method: 'post',
            data
        })
    },
    // 实名认证校验码
    // getRealBindImgCheck() {
    //     return request({
    //     url: '/uc/bind-idcard/captcha',
    //     method: 'get'
    //     })
    // }, 
}


// WEBPACK FOOTER //
// ./src/api/user.js